import { render, staticRenderFns } from "./core-top-users-chart.vue?vue&type=template&id=55f40c9f&scoped=true"
import script from "./core-top-users-chart.vue?vue&type=script&lang=js"
export * from "./core-top-users-chart.vue?vue&type=script&lang=js"
import style0 from "./core-top-users-chart.vue?vue&type=style&index=0&id=55f40c9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f40c9f",
  null
  
)

export default component.exports